module.exports = __webpack_public_path__ + "static/media/logo.6ea824f5.png";